import deepExtend from "deep-extend";

function students(state = {}, action) {
  switch (action.type) {
    case "INIT_STUDENTS_FOR_EVENT":
      var newState = Object.assign({}, state);
      var addState = {
        [action.eventId]: []
      };
      deepExtend(addState, newState);
      return addState;

    case "FETCH_STUDENTS":
      return state;

    case "TOGGLE_STUDENT_PRESENCE":
      var newState = Object.assign({}, state);
      var addState = {};

      if (newState[action.eventId] === undefined) {
        newState = {
          ...newState,
          [action.eventId]: []
        };
      }

      if (!newState[action.eventId].includes(action.studentId)) {
        newState[action.eventId].push(action.studentId);
      } else {
        let index = newState[action.eventId].indexOf(action.studentId);
        newState[action.eventId].splice(index, 1);
      }
      return newState;

    default:
      return state;
  }
  return state;
}

export default students;



// WEBPACK FOOTER //
// ./reducers/students.js